import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {UserDeleteConfirmationDialog} from './user-editor.component';
import {User} from '../../classes/user';
import {AuthenticationService} from '../../services/authentication.service';


@Component({
	selector: 'app-user-delete-confirmation-dialog',
	templateUrl: './user-delete-confirmation-dialog.component.html',
})


export class UserDeleteConfirmation implements OnInit {

  @Input() user = new User();
  @Output() deletedUserId = new EventEmitter<string>();

  constructor(public dialogRef: MatDialogRef<UserDeleteConfirmationDialog>) {
  }


  async ngOnInit() {
  }

}
